export const ACTIONS = {
    INITIALIZE_ALL_EMERGENCIES: 'INITIALIZE_ALL_EMERGENCIES',
    ADD_TO_ALL_EMERGENCY: 'ADD_TO_ALL_EMERGENCY',
    UPDATE_EMERGENCY_FROM_ALL_EMERGENCIES: 'UPDATE_EMERGENCY_FROM_ALL_EMERGENCIES',
    ADD_TO_NEW_EMERGENCIES: 'ADD_TO_NEW_EMERGENCIES',
    REMOVE_FROM_NEW_EMERGENCIES: 'REMOVE_FROM_NEW_EMERGENCIES',
    SET_FILTERED_EMERGENCIES: 'SET_FILTERED_EMERGENCIES',
    SET_SEARCH_TEXT: 'SET_SEARCH_TEXT',
    SET_SHOW_FINISHED: 'SET_SHOW_FINISHED',
    SET_SHOW_TEST: 'SET_SHOW_TEST',
    SET_SELECTED_EMERGENCY: 'SET_SELECTED_EMERGENCY',
    CLEAR_SELECTED_EMERGENCY: 'CLEAR_SELECTED_EMERGENCY',
    SET_PATHS: 'SET_PATHS',
    SET_LOCATIONS: 'SET_LOCATIONS'
}
